"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLOBAL_ROUTES_V1 = void 0;
const admin_page_1 = __importDefault(require("@pages/admin-page"));
const collection_explorer_page_1 = __importDefault(require("@pages/collection-explorer-page"));
const explore_page_1 = __importDefault(require("@pages/explore-page"));
const main_page_1 = __importDefault(require("@pages/main-page"));
const profile_edit_page_1 = __importDefault(require("@pages/profile-edit-page"));
const profile_page_1 = __importDefault(require("@pages/profile-page"));
const referral_page_1 = __importDefault(require("@pages/referral-page"));
const token_page_1 = __importDefault(require("@pages/token-page"));
const token_page_2 = __importDefault(require("@pages/token-page"));
const rating_page_1 = require("@pages/rating-page");
exports.GLOBAL_ROUTES_V1 = [
    {
        path: "/",
        component: main_page_1.default,
        exact: true,
    },
    {
        path: "ref/:refAddress(0x[a-fA-F0-9]{40})",
        component: referral_page_1.default,
        exact: true,
    },
    {
        path: "profile/edit",
        component: profile_edit_page_1.default,
        exact: true,
    },
    {
        path: "profile/(become-creator|collections|stats|ref)?",
        component: profile_page_1.default,
        exact: true,
    },
    {
        path: "profile/:id(0x[a-fA-F0-9]{40})?/(collections|stats|ref)?",
        component: profile_page_1.default,
        exact: true,
    },
    {
        path: "nft/token/:id?",
        component: token_page_1.default,
    },
    {
        path: "explore/:tab?",
        component: explore_page_1.default,
    },
    {
        path: "collection/create",
        component: collection_explorer_page_1.default,
        exact: true,
    },
    {
        path: "collections/:id",
        component: collection_explorer_page_1.default,
        exact: true,
    },
    {
        path: "admin",
        component: admin_page_1.default,
    },
    {
        path: "v2/nft/token/:id?",
        component: token_page_2.default,
    },
    //
    // {
    //   path: "terms",
    //   component: TermsPage,
    // },
    // {
    //   path: "policy",
    //   component: PrivacyPolicyPage,
    // },
    {
        path: "rating",
        component: rating_page_1.RatingPage,
    },
];
